export class TimeoutError extends Error {
  override name = 'TimeoutError';

  constructor(message = 'Timed Out') {
    super(message);
  }
}
